import React, { useState } from 'react';
import { Link, useParams } from "react-router-dom";

// project-imports
import Image from "../footer/Images/Image";
import Spinner from '../../components/spinner-component/SpinnerOne';
import { handleDiscountedPrice, handleMonthlyPrice } from "../../utils/course";
import { checkMediaUrl, getThumbnailFromYouTube, handleFormatProductName, maskPrice } from '../../utils';

// third-party imports
import FsLightbox from 'fslightbox-react';

const OfferingDrawer = ({
    show,
    onClose,
    title = "Product Details",
    offeringsData,
    checkDiscountValidity = () => { },
    infoBtnClick = () => { },
    openHelpModal = () => { },
    checkBtnDisabled = () => { },
    isLoading,
    talkToSalesBtnClick = () => { },
}) => {

    const { productCode } = useParams();

    // local state initialization
    const [toggler, setToggler] = useState(false);

    const currentOffering = (offeringsData || []).filter(
        (item) =>
            item?.productCode?.trim()?.toLowerCase() ===
            productCode?.trim()?.toLowerCase()
    );
    const data = currentOffering && currentOffering?.length ? currentOffering[0] : {};

    // constant variable
    const metaDataObject = data && data?.metadata ? data?.metadata : {};
    const metaDataTags = metaDataObject && metaDataObject?.tags ? metaDataObject?.tags : "";
    const offeringFeatures = data && data?.features && data?.features?.length ? data?.features : [];
    const tags = metaDataTags ? metaDataTags.split(/[,\s]+/) : [];
    const thumbnail = data && data?.media && data?.media?.thumbnailUrl ? data?.media?.thumbnailUrl : "";
    const offeringName = data && data?.name ? data?.name : "";
    const author = data && data?.metadata && data?.metadata?.authorName ? data?.metadata?.authorName : "";
    const pricingType = data && data?.pricing && data?.pricing?.priceType ? data?.pricing?.priceType : "";
    const billing = data && data?.pricing && data?.pricing?.billingCycle ? data?.pricing?.billingCycle : "";
    const btnText = data && data?.purchase && data?.purchase?.buttonText ? data?.purchase?.buttonText : "";
    const level = data && data?.metadata && data?.metadata?.levels ? data?.metadata?.levels : "";
    const download = data && data?.metadata && data?.metadata?.downloads ? data?.metadata?.downloads : 0;
    const offeringLanguage = data && data?.metadata && data?.metadata?.language ? data?.metadata?.language : 0;
    const desc = data && data?.description && data?.description ? data?.description : "";
    const media = data && data?.media && data?.media?.previewUrl ? data?.media?.previewUrl : "";

    // constant function
    const handleVideoError = () => {
        console.log("Video failed to load.");
    };

    let thumbnailUrl = checkMediaUrl(media) ? getThumbnailFromYouTube(media) : "";

    return (
        <>
            {isLoading && <Spinner />}
            <div className={`generic-drawer ${(show || productCode) ? 'active' : ''}`}>
                <div className="inner">
                    <div className="header-top">
                        <div className="logo">
                            <Link to={process.env.PUBLIC_URL + '/'}>
                                <img src="/images/logo/lsa-long-logo.png" alt="Main Logo" />
                            </Link>
                        </div>
                        <h6 className="logo mb-0 text-start fs-3">
                            {title}
                        </h6>
                        <div className="close-menu">
                            <button className="close-button" onClick={onClose}>
                                <i className="ri-close-line"></i>
                            </button>
                        </div>
                    </div>
                    <div className='text-center mt-1'>
                        <div className="container" id="maindiv">
                            <div className="row">
                                <div className="col-12 col-xxl-4">
                                    <div className="image-container pt-3">
                                        <Image
                                            src={`${process.env.PUBLIC_URL}/images/offerings/${thumbnail}`}
                                            alt="Longswitch Academy offerings"
                                            width={170}
                                            height={250}
                                        />

                                    </div>
                                </div>

                                <div className="col-12 col-xxl-8">
                                    <div className="row text-center g-2">
                                        <div className="col-12">
                                            <h5 className="m-0 drawer-title">{handleFormatProductName(offeringName)}</h5>
                                            <h5 className="m-0 drawer-title">({billing})</h5>
                                            <p className="pt-1 m-0">{author}</p>
                                            <p className="pt-2 pb-2 m-0 has-primary-text fw-bold has-large-font-size">
                                                {checkDiscountValidity(data) ? (
                                                    <span className="fs-4 text-decoration-line-through text-secondary mx-1">
                                                        {maskPrice(handleMonthlyPrice(data).formattedAmount)}
                                                    </span>
                                                ) : (
                                                    ""
                                                )}
                                                {checkDiscountValidity(data)
                                                    ? handleDiscountedPrice(data, true)?.formattedAmount
                                                    : maskPrice(handleMonthlyPrice(data).formattedAmount)}

                                                <span className="duration text-lowercase fs-4">
                                                    /per {pricingType}
                                                </span>
                                            </p>
                                        </div>

                                        <div className="col-12">
                                            <div className="pricing-btn">
                                                {checkBtnDisabled(data) ? (
                                                    <button
                                                        className={`edu-btn btn-secondary btn-medium ${data.active !== true ? "" : ""
                                                            }${checkBtnDisabled(data) ? " disabled" : " "}`}
                                                        onClick={() => openHelpModal()}
                                                    >
                                                        {btnText}
                                                        <i className="icon-arrow-right-line-right"></i>
                                                    </button>
                                                ) : (
                                                    <button
                                                        className={`edu-btn btn-secondary btn-medium ${data.active !== true ? "" : ""
                                                            }`}
                                                        // onClick={() => infoBtnClick(data)}
                                                        onClick={() => talkToSalesBtnClick(data)}

                                                    >
                                                        {/* {btnText} */}
                                                        Talk to Sales
                                                        <i className="icon-arrow-right-line-right"></i>
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                        {/* Levels & Enrolled */}
                                        <div className="col-12 pt-3">
                                            <div className="row">
                                                <div className="col-6 col-sm-3 pt-2">
                                                    <p className="p-0 m-0">Level</p>
                                                    <div className="fw-bold text-capitalize">
                                                        {/* {data?.metadata?.levels || "Beginner"} */}
                                                        {level || "Beginner"}
                                                    </div>
                                                </div>
                                                <div className="col-6 col-sm-3 pt-2">
                                                    <p className="p-0 m-0">Enrolled</p>
                                                    <div className="fw-bold text-capitalize">
                                                        {/* {data?.metadata?.downloads || 0} */}
                                                        {download || 0}
                                                    </div>
                                                </div>
                                                <div className="col-6 col-sm-3 pt-2">
                                                    <p className="p-0 m-0">Duration</p>
                                                    <div className="fw-bold ">
                                                        {/* {data?.pricing?.billingCycle || 0} */}
                                                        {billing || 0}
                                                    </div>
                                                </div>
                                                <div className="col-6 col-sm-3 pt-2">
                                                    <p className="p-0 m-0">Language</p>
                                                    <div className="fw-bold text-capitalize">
                                                        {/* {data?.metadata?.language || "English"} */}
                                                        {offeringLanguage || "English"}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 pt-4">
                                    <div className="row px-4">
                                        <div className="col-12 text-start">
                                            <div className="fw-bold fs-2">Description</div>
                                        </div>
                                        <div className="col-12 text-start ps-5">
                                            <p className="m-0">{desc}</p>
                                        </div>
                                    </div>
                                </div>

                                {offeringFeatures && (
                                    <div className="col-12 pt-4">
                                        <div className="row px-4">
                                            <div className="col-12 text-start">
                                                <div className="fw-bold fs-2">Features</div>
                                            </div>
                                            <div className="col-12 text-start ps-5 mb-2">
                                                <ul className="mb-0">
                                                    {(offeringFeatures || [])?.map((item, i) => (
                                                        <li key={i}>{item}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {tags && tags?.length && (
                                    <div className="col-12">
                                        <div className="row px-4">
                                            <div className="col-12 text-start">
                                                <div className="fw-bold fs-2">Tags</div>
                                            </div>
                                            <div className="rating eduvibe-course-rating-stars mt-0 text-start">
                                                {/* <StarRating data={data} /> */}
                                                {(tags || [])?.map((item, i) => (
                                                    <span class="fs-5 badge text-success rounded-pill bg-success bg-opacity-25 text-capitalize mx-1" key={i}>{item}</span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {media && checkMediaUrl(media) && (
                                    <div className="col-12 pt-4">
                                        <div className="row px-4">
                                            <div className="col-12 text-start">
                                                <div className="fw-bold fs-2">Watch Preview</div>
                                            </div>

                                            <div className="col-12 video-area eduvibe-widget">
                                                <div className="thumbnail video-popup-wrapper">
                                                    {/* working as aspected code start  */}
                                                    <video
                                                        className="radius-small w-100"
                                                        controls
                                                        poster={
                                                            thumbnailUrl ||
                                                            `${process.env.PUBLIC_URL}/images/course/video-bg/default-image.jpg`
                                                        }
                                                        onError={handleVideoError}
                                                    >
                                                        <source src={[media]} type="video/mp4" />
                                                        Your browser does not support the video tag.
                                                    </video>

                                                    {/* working as aspected code  */}

                                                    <button
                                                        onClick={() => setToggler(!toggler)}
                                                        className="video-play-btn position-to-top video-popup-activation"
                                                    >
                                                        <span className="play-icon"></span>
                                                    </button>
                                                    <FsLightbox toggler={toggler} sources={[media]} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>)}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default OfferingDrawer;